import React from 'react'
import {
  DownloadItem,
  DownloadTitle,
  FreeIcon,
  NavDropDownWrapper,
  SupportCenterDivider,
  SupportColumnWrapper,
  SupportContact,
  SupportDownloadWrapper,
  SupportDropDownWrapper,
  SupportItem,
  SupportItemWrapper,
  SupportRightWrapper,
} from './atoms'
import intl from 'react-intl-universal'
import { DownloadIcon1, DownloadIcon2, DownloadIcon3, ContactIcon } from './svg'
import { showContact } from '../../utils'
import { LOCALE } from '@foxrenderfarm/internals'
import { Link } from 'gatsby'

const tos = [
  '/download.html',
  '/support/',
  '/support/rendering-tutorial/',
  '/support/general/',
  '/support/pricing-and-billing/',
  '/support/user-center/',
  '/support/developer-center/',
]

interface Props {
  item: {
    name: string
    key: string
    children: { to: string; key: string; name: string }[]
    to?: string
  }
  currentLocale: LOCALE
  origin: string
  currentPathname: string
}

export const SupportDropDown = ({ currentLocale, origin, currentPathname }: Props) => {
  return (
    <NavDropDownWrapper key='support' $isActive={tos.includes(currentPathname)} $left={-250}>
      {intl.get('index.header.support')}
      <div className='navDropDown'>
        <SupportDropDownWrapper>
          <SupportDownloadWrapper
            as={process.env.GATSBY_PACKAGE_NAME === 'main' ? Link : 'a'}
            to={currentLocale === 'en' ? '/download.html' : `/${currentLocale}/download.html`}
            href={currentLocale === 'en' ? '/download.html' : `/${currentLocale}/download.html`}
          >
            <FreeIcon>{intl.get('index.header.support.free')}</FreeIcon>
            <DownloadTitle>{intl.get('index.header.support.download')}</DownloadTitle>
            <DownloadItem>
              <DownloadIcon1 />
              {intl.get('index.header.support.download.item1')}
            </DownloadItem>
            <DownloadItem>
              <DownloadIcon2 />
              {intl.get('index.header.support.download.item2')}
            </DownloadItem>
            <DownloadItem>
              <DownloadIcon3 />
              {intl.get('index.header.support.download.item3')}
            </DownloadItem>
          </SupportDownloadWrapper>
          <SupportCenterDivider />
          <SupportRightWrapper>
            <SupportItemWrapper>
              <SupportColumnWrapper>
                <SupportItem href={`${origin}/support/`}>
                  {intl.get('index.header.support.center')}
                </SupportItem>
                <SupportItem href={`${origin}/support/rendering-tutorial/`}>
                  {intl.get('index.header.support.rendering.tutorial')}
                </SupportItem>
                <SupportItem href={`${origin}/support/general/`}>
                  {intl.get('index.header.support.general')}
                </SupportItem>
              </SupportColumnWrapper>
              <SupportColumnWrapper>
                <SupportItem href={`${origin}/support/pricing-and-billing/`}>
                  {intl.get('index.header.support.pricing.billing')}
                </SupportItem>
                <SupportItem href={`${origin}/support/user-center/`}>
                  {intl.get('index.header.support.user')}
                </SupportItem>
                <SupportItem href={`${origin}/support/developer-center/`}>
                  {intl.get('index.header.support.developer')}
                </SupportItem>
              </SupportColumnWrapper>
            </SupportItemWrapper>
            <SupportContact onClick={showContact}>
              <ContactIcon />
              {intl.get('index.header.support.contact')}
            </SupportContact>
          </SupportRightWrapper>
        </SupportDropDownWrapper>
      </div>
    </NavDropDownWrapper>
  )
}
